/* eslint-disable no-console */
import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered (registration) {
      console.log('Service worker has been registered.')

      // check for update every 5 seconds
      setInterval(() => {
        // eslint-disable-next-line no-undef
        registration.update()
      }, 5000);
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound (registration) {
      console.log('New content is downloading.')
      
      // When new content is found, wait for the new service worker to finish installing
      const newWorker = registration.waiting;
      if (newWorker) {
        newWorker.addEventListener('statechange', () => {
          // Listen for when the new service worker becomes "activated"
          if (newWorker.state === 'activated') {
            // Once activated, you can inform the user or refresh the page
            console.log('New service worker is activated.');
            document.dispatchEvent(
              new CustomEvent('swUpdated', { detail: registration })
            );
          }
        });
      }
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      document.dispatchEvent(
        new CustomEvent('swUpdated', { detail: registration })
      )
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}